<template>
  <div id="app" style="width: 100%;height: 100vh; overflow-x: hidden;">
    <router-view v-if="$route.name == 'login' || $route.name == 'm'"></router-view>
    <div class="page flex-col" v-if="$route.name !== 'login' && $route.name !== 'm'">
      <div class="bd1 flex-col">
        <div class="outer1 flex-row justify-between">
          <div class="bd2 flex-col">
            <div class="outer2 flex-col">
              <div class="box1 flex-row justify-between">
                <img class="pic1" referrerpolicy="no-referrer" src="./views/assets/img/yhpsqy.png" />
              </div>
              <div style="cursor:pointer;" :class="index == $store.state.stidx ? 'box2' : 'box2s'"
                @click="idxfun(index, item.tit, item.path)" v-for="(item, index) in listnav" :key="index">
                <div class="box3 flex-row justify-between">
                  <img :src="require('./views/assets/img/home' + index + '.png')" style="width:20px;height: 20px;">
                  <span class="word1">{{ item.tit }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bd6 flex-col justify-between">
            <div class="box10 flex-col">
              <div class="outer6">
                <!-- <span class="info3" style="font-weight: bold;float: left;">{{title}}</span> -->
                <el-breadcrumb separator="/" class="info3" style="font-weight: bold;float: left;">
                  <el-breadcrumb-item :to="{ path: '/TalentPool' }">{{ title }}</el-breadcrumb-item>
                  <el-breadcrumb-item v-if="title_2 != ''">{{ title_2 }}</el-breadcrumb-item>
                  <!-- <el-breadcrumb-item>{{}}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{}}</el-breadcrumb-item> -->
                </el-breadcrumb>
                <span style="float: right;" class="info4"><el-button size="mini" round
                    @click="clear()">退出登录</el-button></span>
              </div>
            </div>
            <router-view> </router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ZoomRatio from '@/utils/ZoomRatio'
import DevicePixelRatio from '@/utils/devicePixelRatio'
export default {
  data() {
    return {
      listnav: [
        { tit: '首页', path: '/home' },
        { tit: '候选人管理', path: '/Candidate' },
        { tit: '岗位管理', path: '/Talent' },
        { tit: '人才信息库', path: '/TalentPool' },
      ],
      title: '',
      title_2: '',
      path: '/home'
    };
  },
  created() {
    // new ZoomRatio().init()
    // new DevicePixelRatio().init()
  },
  methods: {
    idxfun(index, tit, path) {
      this.title = tit;
      this.$store.state.stidx = index;
      this.$router.push({ path: path })
    },
    clear() {
      this.$confirm('是否确定退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'login' });
        localStorage.setItem("Authorization", null);
        localStorage.clear();
      })
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  watch: {
    "$route.name": {
      handler: function (val) {
        if (val == 'Candidate') {
          this.title = "候选人管理";
          this.title_2 = "";
          this.path = '/' + val.toString();
        } else if (val == 'Candidateils') {
          this.title = "候选人管理";
          this.title_2 = "候选人详情";
        } else if (val == 'Talent') {
          this.title = "岗位管理";
          this.title_2 = "";
          this.path = '/' + val.toString();
        } else if (val == 'Talentils') {
          this.title = "岗位管理";
          this.title_2 = "岗位详情";
        } else if (val == 'TalentPool') {
          this.title = "人才信息库";
          this.title_2 = "";
          this.path = '/' + val.toString();
        } else if (val == 'TalentPoolils') {
          this.title = "人才信息库";
          this.title_2 = "人才信息库详情";
        } else if (val == 'home') {
          this.title = "首页";
          this.title_2 = "";
          this.path = '/' + val.toString();
        }
      },
    },
  },
  mounted() {
    if (this._isMobile()) {
      this.$router.replace('/m');
      return;
    }
    if (sessionStorage.getItem("store")) {
      this.$store.state.stidx = sessionStorage.getItem("store");
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", this.$store.state.stidx)
    })
  },
};
</script>
<style lang="less" scoped>

div {
  user-select: none !important;
}

.page .bd1 .outer1 .bd2 .outer2 .box2 .word1 {
  line-height: 18px !important;
  color: #fff !important;
}

.page .bd1 .outer1 .bd2 .outer2 .box2s .word1 {
  line-height: 18px !important;
}

.page .bd1 .outer1 .bd2 .outer2 .box2s {
  height: 48px;
  border-radius: 4px;
  margin-top: 10px;
  width: 200px;
}

.page .bd1 .outer1 .bd2 .outer2 .box2 {
  margin-top: 10px !important;
}
</style>
<style lang="less" src="./views/assets/index.less" />
<style src="./assets/css/common.css" />
